import { AppBskyLabelerService } from "@atproto/api";
import { getRecord, GetRecordOpts } from "./getRecord";

export function getLabelerServiceRecord(did: string, opts: GetRecordOpts<AppBskyLabelerService.Record>) {
  const atUriString = `at://${did}/app.bsky.labeler.service/self`;
  opts.isValidRecord ??= AppBskyLabelerService.isRecord;
  return getRecord<AppBskyLabelerService.Record>(atUriString, opts);
}
